import { Users, Sun, Building2 } from "lucide-react";
import { SlideHeader, Headline, InfoBoxGrid, DeepDive } from "../shared";

export function Slide11Customer() {
  const BOXES = [
    { title: "First Customer", body: "Active women, about 25 to 40. Already buy skin care, spend long days away from home, and value attractive wearable design.", icon: Users },
    { title: "Entry Point", body: "Sunscreen on active days. The same dispenser holds other liquids, lotions and gels, so the platform can extend beyond sun care.", icon: Sun },
    { title: "Brand Partners", body: "Easier, appropriate application may support the product experience and repeat purchasing. Pilots will test whether it does.", icon: Building2 },
  ];
  const BRAND_PORTFOLIO = [
    "La Roche-Posay", "CeraVe", "Vaseline", "Dermalogica", "SkinCeuticals", "Vichy",
    "NIVEA", "Eucerin", "Coppertone", "Dove", "Paula's Choice", "Clinique",
  ];
  const CONSUMER_MOMENTS = [
    "Running, cycling and golf",
    "Surfing, sailing and boating",
    "Travel and commuting",
    "Heat, perspiration and UV exposure",
    "Whenever the bottle is at home, in the car or in a bag",
  ];
  return (
    <div className="max-w-4xl" data-testid="pitch-slide-customer">
      <SlideHeader n="12" label="Customer & Brand" />
      <Headline>
        Active consumers first. <span className="text-accent">A wider skin care platform next.</span>
      </Headline>
      <p className="font-heading text-white text-lg md:text-xl font-medium mt-4 max-w-2xl">
        Built first for <span className="text-accent">people whose personal care has to move with them.</span>
      </p>
      <InfoBoxGrid testid="pitch-customer-boxes" boxes={BOXES} />
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-5">
        Entry market: global sun care, about $15.5B in 2025, per Fortune Business Insights.
      </p>
      <div className="flex flex-wrap gap-3 mt-4">
        <DeepDive testid="customer-consumer" label="Who We're Building For" title="High-Friction Moments">
          <div className="space-y-2.5">
            {CONSUMER_MOMENTS.map((t) => (
              <div key={t} className="flex items-start gap-2.5">
                <span className="w-1 h-1 rounded-full bg-accent mt-2 shrink-0" />
                <p className="font-body text-zinc-300 text-sm leading-relaxed">{t}</p>
              </div>
            ))}
          </div>
        </DeepDive>
        <DeepDive testid="customer-brand" label="Brand Portfolio Fit" title="What Makes the Partner Ideal">
          <p className="font-body text-zinc-300 text-sm leading-relaxed">
            Brand portfolios with high fit for wearable, on-body delivery, spanning sun care,
            moisturizer, treatment, body care and adjacent topical categories:
          </p>
          <div className="flex flex-wrap gap-2 mt-4">
            {BRAND_PORTFOLIO.map((b) => (
              <span key={b} className="font-mono text-[10px] tracking-[0.08em] uppercase text-zinc-300 border border-zinc-700 rounded-full px-3 py-1.5">
                {b}
              </span>
            ))}
          </div>
        </DeepDive>
      </div>
    </div>
  );
}
